"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _pdp_tabs = require("./pdp_tabs");

var _pdp_tabs2 = _interopRequireDefault(_pdp_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PdpStickyHeader = function (_React$PureComponent) {
  _inherits(PdpStickyHeader, _React$PureComponent);

  function PdpStickyHeader(props) {
    _classCallCheck(this, PdpStickyHeader);

    var _this = _possibleConstructorReturn(this, (PdpStickyHeader.__proto__ || Object.getPrototypeOf(PdpStickyHeader)).call(this, props));

    _this.renderStickyFeaturedFundIcon = function () {
      return _this.props.fund.fundFocusIndicator && (0, _functional_utility.doesVisibleDataPointContains)("SHOW_FEATURED_FUND_ICON", _this.props) && _react2.default.createElement("div", { id: "featured-fund-icon", className: "pdp-featured-fund-indicator display-inline-block" });
    };

    _this.renderFundName = function () {
      var fundNameToDisplay = (0, _functional_utility.doesVisibleDataPointContains)("SHOW_SHARECLASS_NAME", _this.props) ? _this.props.fund.shareClass.name : _this.props.fund.name;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "div",
          {
            className: "body-bold overflow-hidden white-space-nowrap overflow-ellipsis height-32 margin-top padding-right-20 padding-left-20 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4",

            id: "fund-name" },
          fundNameToDisplay,
          _this.props.renderDashShareclass(),
          _this.props.renderFundNameDisclosure()
        )
      );
    };

    _this.renderStickySummaryFundDetails = _this.renderStickySummaryFundDetails.bind(_this);
    return _this;
  }

  _createClass(PdpStickyHeader, [{
    key: "renderStickySummaryFundDetails",
    value: function renderStickySummaryFundDetails() {
      var additionalMargin = void 0;
      var breakpoint = this.props.breakpoint;

      var maxHeightStyle = breakpoint === 3 ? '' : ' max-height-440';
      var fundNameHeight = this.fundNameEl ? this.fundNameEl.offsetHeight : 0;

      if (fundNameHeight > 82 && !this.props.hasShareClassSelector()) {
        additionalMargin = " margin-top-";
      }

      var shareClassAndJumpToFund = _react2.default.createElement(
        _react.Fragment,
        null,
        this.props.renderJumpToFundApp({
          additionalMargin: additionalMargin,
          isStickyHeaderVisible: true
        })
      );

      var shareClassJumpToFundRow = _react2.default.createElement(
        "div",
        { id: "jump-to-fund-sticky",
          "data-testid": "shareclass-jtf-div",
          className: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xlg-3 padding-all-0 margin-vertical-13 height-38" },
        shareClassAndJumpToFund
      );

      return _react2.default.createElement(
        "div",
        { id: "summaryHeaderFundDetails",
          className: "col-xs-12 col-md-12 col-lg-12 col-xlg-12 funds-div margin-left-0 margin-right-0 pull-left " + _functional_utility2.default.conditionCheck(breakpoint < 3, "padding-horizontal-16", maxHeightStyle) + " display-inline-block" },
        _react2.default.createElement(
          "div",
          {
            className: "row margin-all-0 width-percent-100" },
          _react2.default.createElement(
            "div",
            {
              className: "" + _functional_utility2.default.conditionCheck(breakpoint < 3, "display-inline-block float-left width-percent-80 margin-top-18 line-height-15", "line-height-32") },
            this.props.renderBrandImage('sticky-header-enabled'),
            _react2.default.createElement(
              "div",
              { className: "display-inline-flex width-percent-100",
                style: { 'verticalAlign': 'text-bottom', 'align-items': 'center' } },
              this.props.fund.isDigitalShareFund ? _react2.default.createElement("span", { className: "fx-digital-share-fund-indicator" }) : null,
              this.renderStickyFeaturedFundIcon(),
              this.renderSummaryHeaderTicker(breakpoint, this.props.fund),
              this.props.showShareclassSelector(true),
              this.renderFundName(),
              shareClassJumpToFundRow
            )
          )
        )
      );
    }
  }, {
    key: "renderSummaryHeaderTicker",
    value: function renderSummaryHeaderTicker(breakpoint, fund) {

      if ((0, _ramda.includes)("SHOW_VALOREN", fund.visibleData.visibleDataPoints)) {
        return _react2.default.createElement(
          "div",
          { id: "header-valoren",
            className: "margin-right-20 height-32 " + (fund.shareClass.valoren === 'N/A' ? "display-none" : "display-block") + " " + (breakpoint < 3 ? "display-inline-block padding-bottom-10 float-left width-percent-10" : "display-inline-block float-left"),
            style: breakpoint > 3 ? { "paddingTop": "1.4px" } : {} },
          "Valor ",
          fund.shareClass.valoren === 'N/A' ? "" : fund.shareClass.valoren
        );
      } else if (!(0, _ramda.includes)("SUPPRESS_HEADER_TICKER", fund.visibleData.visibleDataPoints)) {
        return _react2.default.createElement(
          "div",
          { id: "ticker", "data-testid": "header-ticker",
            className: "margin-right-20 height-32 " + (fund.shareClass.headerTicker === 'N/A' ? "display-none" : "display-block") + " " + (breakpoint < 3 ? "display-inline-block padding-bottom-10 float-left width-percent-10" : "display-inline-block float-left"),
            style: breakpoint > 3 ? { "paddingTop": "1.4px" } : {} },
          fund.shareClass.headerTicker === 'N/A' ? "" : fund.shareClass.headerTicker
        );
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var summaryHeaderBackgroundColor = this.props.summaryHeaderBackgroundColor;

      return _react2.default.createElement(
        "div",
        null,
        this.props.renderSummaryAlerts(true),
        _react2.default.createElement(
          "div",
          { className: "line-height-64 fluid-container " + summaryHeaderBackgroundColor },
          _react2.default.createElement(
            "div",
            { "data-testid": "hero-image-background",
              className: "pdp-summary-header-background header-background print-hide-image print-white-background" },
            _react2.default.createElement(
              "div",
              {
                className: "container" },
              _react2.default.createElement(
                "div",
                { className: "row" },
                this.renderStickySummaryFundDetails()
              )
            )
          )
        ),
        this.renderTabs()
      );
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      var _props = this.props,
          tabProps = _props.tabProps,
          listOfAllTabs = _props.listOfAllTabs,
          updateTabState = _props.updateTabState,
          fund = _props.fund;

      return _react2.default.createElement(_pdp_tabs2.default, { tabProps: tabProps,
        listOfAllTabs: listOfAllTabs,
        updateTabState: updateTabState,
        fundTypeCode: fund.fundTypeCode });
    }
  }]);

  return PdpStickyHeader;
}(_react2.default.PureComponent);

exports.default = PdpStickyHeader;